<template>
  <div class="container">
    <div class="content">
      <img src="../assets/404.png" alt="">
      <h2>Oops! You must be lost..</h2>
      <p class="title">Looks like you've followed a broken link or entered the wrong address.</p>
      <p class="con">It happens don't worry 🙂</p>
      <p class="count">You'll be redirected in {{ formatTime }}</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      time: 10, // 30 seconds in seconds
    };
  },

  computed: {
    formatTime() {
      const hours = Math.floor(this.time / 3600);
      const minutes = Math.floor((this.time % 3600) / 60);
      const seconds = this.time % 60;

      if (hours > 0) {
        return `${hours}h ${minutes}min ${seconds}s`;
      } else if (minutes > 0) {
        return `${minutes}min ${seconds}s`;
      } else {
        return `${seconds}s`;
      }
    },
  },

  methods: {
    startCountdown() {
      setInterval(() => {
        if (this.time > 0) {
          this.time--;
        } else {
          window.location.href = '/';
        }
      }, 1000);
    },
  },
  mounted() {
    this.startCountdown();
  },
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: center;
  text-align: center;
  min-height: 100vh;
  z-index: 2000;
  
  .content {
    margin: auto;
    padding: 0 10%;
    
    img {
      width: 50%;
      height: auto;
    }

    h2 {
      padding-bottom: 3%; 
    }

    p {
      font-size: 100%;
    }

    .title {
      padding-bottom: 2%;
    }

    .con {
      padding-bottom: 1%;
    }

    .count {
      display: inline-flex;
    }
  }
}
</style>